import './thrivekitchen/style';
import FormStructure from './thrivekitchen/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js